<template>
  <div class="home">

    <h1 class="title is-1">Christian Accountability v0.4</h1>

    <hr>

    <h3 v-if="showTemplateChooser" class="title is-3">Choose your question template: 
      <button @click="selectTemplate('leader')" class="button is-info">Pastoral Leader</button>&nbsp;
      <button @click="selectTemplate('marriage')" class="button is-success">Marriage</button>&nbsp;
      <button @click="selectTemplate('india')" class="button is-warning">India (हिंदी)</button>
    </h3>

    <div v-if="showTemplate">
      <div v-for="(category, index) in questions.categories" v-bind:key="index">
        <category :lang="lang" :categoryData="category" :viewResponses="false" />
      </div>
      <button class="button is-link" @click="submitReport">{{ submitText }}</button>
    </div>


  </div>
</template>

<script>
import axios from "axios";

import questionsLeader from "../questions/leader.js"
import questionsIndia from "../questions/india.js"
import questionsMarriage from "../questions/marriage.js"
import category from "../components/Category.vue"

export default {
  name: 'home',
  data: function() {
    return {
      questions: null,
      allReports: [],
      showTemplateChooser: true,
      showTemplate: false,
      questionsLeader: questionsLeader,
      questionsIndia: questionsIndia,
      questionsMarriage: questionsMarriage,
      lang: "en",
      submitText: "Submit Accountability Report"
    }
  },
  components: {
    category: category
  },
  methods: {
    selectTemplate(name) {

      if (name === "india") {
        this.questions = this.questionsIndia
        this.submitText = "जवाबदेही फॉर्म जमा करें"
        this.lang = "hi"
      } else if (name === "leader") {
        this.questions = this.questionsLeader
        this.lang = "en"
      } else if (name === "marriage") {
        this.questions = this.questionsMarriage
        this.lang = "en"
      }

      this.showTemplate = true;
      this.showTemplateChooser = false;
    },
    submitReport: function() {
      axios.get("https://vps.stouthearted.com/couchdb/_uuids")
        .then(response => {
          //console.log(response)
          let uuid = response.data.uuids[0]
          this.questions.reportGuid = uuid;
          axios.put("https://vps.stouthearted.com/couchdb/accountability_reports/" + uuid, this.questions)
            .then(responseReport => {
              //console.log(responseReport.data)
              //window.alert("Sucessfully created report.")
              this.$router.push({ name: "report", params: { id: responseReport.data.id } })
            })
        })

    }
  }
}
</script>
